import { createMuiStyles } from '../../utils/mui';
export const errorComponentStyles = createMuiStyles({
  svg: {
    width: 'clamp(18rem, 100%, 60rem)',
    height: 'auto',
  },
  contentContainer: {
    textAlign: {
      xs: 'center',
      md: 'left',
    },
    marginTop: { xs: 4, md: 0 },
  },
});
